import {Factory} from './Factory'
import Menu from '../EditorComponents/Heading/Menu'
export class HeadingFactory extends Factory {
  constructor(qty = 1) {
    super()
    this.qty = qty
  }

  object() {
    return {
      id: this.id('heading'),
      slug: 'editor-heading',
      assets: {
        phone: [],
        tablet: [],
        desktop: []
      },
      background: {
        phone: 'color',
        tablet: 'color',
        desktop: 'color'
      },
      customClasses: [],
      constantClasses: {
        phone: [],
        tablet: [],
        desktop: []
      },
      containerClasses:{
        phone: [],
        tablet: [],
        desktop:[]
      },
      name: 'Heading',
    }
  }

  properties() {
    return {
      content: [
        {key: 'text-content', component: 'ContentText', text: 'text', property: 'text'},
      ],
      styles: [
        {key: 'text-color', component: 'TextColorProperty'},
        {key: 'text-alignment', component: 'TextAlignmentProperty'},
        {key: 'font-size', component: 'FontSizeProperty'},
        {key: 'font-weight', component: 'FontWeightProperty'},
        {key: 'margin', component: 'MarginProperty'},
      ],
      advanced: [
        {key: 'element-id', component: 'ElementId'},
        {key: 'custom-classes', component: 'CustomClasses'},
        {key: 'custom-styles', component: 'CustomStyles'},
      ],
      menu: Menu
    }
  }
}